var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"badge px-2 py-1",class:_vm.badgeClass},[_vm._v(" "+_vm._s(_vm.badgeText)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }